import React from "react";
import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { coverType, typeOFCOVER } from "../../Constant";

const obj = {
  dob: "",
  gender: "",
  relationship: "",
  annualI: "",
  si: "",
};

const data = {
  adult: 2,
  child: 1,
  adultData: [
    { dob: "", gender: "", error: false },
    { dob: "", gender: "", error: false },
  ],
  childData: [{ dob: "", gender: "", error: false }],
  pincode: "",
  dropDownopen: false,
  email: "",
  phn: "",
  check: true,
  dropDownError: false
}

const initialState = {
  adultMember: [obj, obj],
  childMember: [obj],
  coverType: typeOFCOVER.ff,
  plandata: data,
};

export const CIReducer = createSlice({
  name: "CI",
  initialState,
  reducers: {
    InitialState: () => initialState,
    onMinusButtonCall: (state, action) => {
      if (action.payload.type === "Adult") {
        state.adultMember.pop();
      } else {
        state.childMember.pop();
      }
    },
    onPlusButtonCall: (state, action) => {
      if (action.payload.type === "Adult") {
        state.adultMember.push(obj);
      } else {
        if (state.coverType !== typeOFCOVER.ml) {
          state.childMember.push(obj);
        } else {
          message.error("Cannot add child in Multi Individual Case");
        }
      }
    },
    onDatePickerChange: (state, action) => {
      const { pos, type, value } = action.payload;
      if (type === "Adult") {
        const newArr = [...state.adultMember];
        newArr[pos] = { ...newArr[pos], dob: value };
        state.adultMember = newArr;
      } else {
        const newArr = [...state.childMember];
        newArr[pos] = { ...newArr[pos], dob: value };
        state.childMember = newArr;
      }
    },
    onGenderChange: (state, action) => {
      const { pos, type, value } = action.payload;
      if (type === "Adult") {
        const newArr = [...state.adultMember];
        newArr[pos] = { ...newArr[pos], gender: value };
        state.adultMember = newArr;
      } else {
        const newArr = [...state.childMember];
        newArr[pos] = { ...newArr[pos], gender: value };
        state.childMember = newArr;
      }
    },
    onRelationshipChange: (state, action) => {
      const { pos, type, value } = action.payload;
      if (type === "Adult") {
        const newArr = [...state.adultMember];
        newArr[pos] = { ...newArr[pos], relationship: value };
        if (state.coverType === typeOFCOVER.ff) {
          newArr[pos] = { ...newArr[pos], relationship: value, annualI: 0 };
        }
        state.adultMember = newArr;
      } else {
        const newArr = [...state.childMember];
        newArr[pos] = { ...newArr[pos], relationship: value };
        state.childMember = newArr;
      }
    },
    onAmountChange: (state, action) => {
      const { pos, type, value } = action.payload;
      if (type === "Adult") {
        const newArr = [...state.adultMember];
        newArr[pos] = { ...newArr[pos], annualI: value };
        state.adultMember = newArr;
        if (state.coverType === typeOFCOVER.ff && (pos === 0 || pos === 1)) {
        }
      } else {
        const newArr = [...state.childMember];
        newArr[pos] = { ...newArr[pos], annualI: value };
        state.childMember = newArr;
      }
    },
    onSIChange: (state, action) => {
      const { pos, type, value } = action.payload;
      if (type === "Adult") {
        const newArr = [...state.adultMember];
        newArr[pos] = { ...newArr[pos], si: value };
        state.adultMember = newArr;
      } else {
        const newArr = [...state.childMember];
        newArr[pos] = { ...newArr[pos], si: value };
        state.childMember = newArr;
      }
    },
    onChangeCoverType: (state, action) => {
      const adultdata = [...state.adultMember].map((ei, i) => {
        if (i !== 0) {
          ei.annualI = ""

        }
        return ei
     });
      if (action.payload === typeOFCOVER.ml) {
        state.childMember = [];
        state.adultMember = adultdata;
      }
      if (action.payload === typeOFCOVER.ff) {
        state.adultMember = adultdata;
      }
      state.coverType = action.payload;
    },
    setPlanData: (state, action) => {
      state.plandata = action.payload
    },
    setInitialState: (state,action) => {
      state = {...state, ...action.payload}
    }
  },
});

export const {
  InitialState,
  onPlusButtonCall,
  onMinusButtonCall,
  onDatePickerChange,
  onGenderChange,
  onRelationshipChange,
  onAmountChange,
  onSIChange,
  setPlanData,
  onChangeCoverType,
  setInitialState,
} = CIReducer.actions;

export default CIReducer.reducer;
